/**
 * @generated SignedSource<<aaee72412b75acd6d9db9cf1c1f19413>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZohoUpdateSettingsInput = {
  clientMutationId?: string | null | undefined;
  salesIqAppCode?: string | null | undefined;
  salesIqAppId?: string | null | undefined;
  salesIqPortalId?: string | null | undefined;
};
export type Integration_ZohoUpdateSettings_Mutation$variables = {
  input: ZohoUpdateSettingsInput;
};
export type Integration_ZohoUpdateSettings_Mutation$data = {
  readonly zohoUpdateSettings: {
    readonly salesIqAppId: string | null | undefined;
    readonly salesIqPortalId: string | null | undefined;
  } | null | undefined;
};
export type Integration_ZohoUpdateSettings_Mutation = {
  response: Integration_ZohoUpdateSettings_Mutation$data;
  variables: Integration_ZohoUpdateSettings_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ZohoUpdateSettingsPayload",
    "kind": "LinkedField",
    "name": "zohoUpdateSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesIqPortalId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesIqAppId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_ZohoUpdateSettings_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Integration_ZohoUpdateSettings_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0fb20da49c56dd9f1a877262f846eccf",
    "id": null,
    "metadata": {},
    "name": "Integration_ZohoUpdateSettings_Mutation",
    "operationKind": "mutation",
    "text": "mutation Integration_ZohoUpdateSettings_Mutation(\n  $input: ZohoUpdateSettingsInput!\n) {\n  zohoUpdateSettings(input: $input) {\n    salesIqPortalId\n    salesIqAppId\n  }\n}\n"
  }
};
})();

(node as any).hash = "4990452d1e7aa3af529826173dc3cb34";

export default node;
